import { FormControl, TextField } from '@mui/material'
import React, { ChangeEventHandler, useCallback } from 'react'
import { useListFilters } from 'shared/api/list'

export function StringFilter({
  filterKey,
  label,
}: {
  filterKey: string
  label: string
}) {
  const {
    filters: { [filterKey]: value },
    setFilter,
  } = useListFilters()
  const onChange: ChangeEventHandler<HTMLTextAreaElement> = useCallback(
    (e) => {
      if (!e.target.value) {
        setFilter(filterKey, undefined)
      } else {
        setFilter(filterKey, e.target.value)
      }
    },
    [filterKey, setFilter],
  )
  return (
    <FormControl sx={{ m: 1, width: 175 }}>
      <TextField
        variant="filled"
        label={label}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  )
}
